import { render, staticRenderFns } from "./fourbanner.vue?vue&type=template&id=69d90c6c&scoped=true&"
import script from "./fourbanner.vue?vue&type=script&lang=js&"
export * from "./fourbanner.vue?vue&type=script&lang=js&"
import style0 from "./fourbanner.vue?vue&type=style&index=0&id=69d90c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d90c6c",
  null
  
)

export default component.exports